import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Tengo que tomar pastillas para dormir?',
  a: 'No. Este método se basa en regular tus hormonas de forma natural mediante hábitos, luz, temperatura y minerales como el magnesio.'
}, {
  q: '¿Funciona si tengo muy poco tiempo en la noche?',
  a: 'Sí. Fue diseñado específicamente para mujeres ocupadas. El protocolo de vaciado mental toma solo 5 minutos.'
}, {
  q: '¿Es solo para mujeres mayores de 40?',
  a: 'Está enfocado en los cambios hormonales que ocurren a partir de los 40, pero las estrategias de higiene del sueño funcionan para cualquier edad.'
}, {
  q: '¿Cómo recibo la guía?',
  a: 'Inmediatamente después de tu compra recibes un correo con el enlace de descarga. Es un PDF que puedes leer en cualquier dispositivo.'
}, {
  q: '¿Qué pasa si no me funciona?',
  a: 'Tienes 7 días de garantía total. Si no estás satisfecha, te devolvemos el 100% sin preguntas.'
}, {
  q: '¿Cuánto tiempo toma ver resultados?',
  a: 'Muchas mujeres notan cambios en la primera semana al implementar la higiene de luz y el protocolo de vaciado mental.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="bg-cream py-16 md:py-24 px-4" data-id="element-60">
      <div className="max-w-3xl mx-auto" data-id="element-61">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-62">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-olive" data-id="element-63">
            ¿Tienes dudas?
          </h2>
        </motion.div>

        <div className="space-y-4" data-id="element-64">
          {faqs.map((faq, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1
        }} className="bg-white rounded-2xl shadow-sm border border-sage/10 overflow-hidden" data-id="element-65">
              <button onClick={() => setOpenIndex(openIndex === idx ? null : idx)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" data-id="element-66">
                <span className="font-bold text-olive pr-4" data-id="element-67">{faq.q}</span>
                <ChevronDown className={`w-5 h-5 text-sage transition-transform duration-300 flex-shrink-0 ${openIndex === idx ? 'rotate-180' : ''}`} data-id="element-68" />
              </button>

              <AnimatePresence data-id="element-69">
                {openIndex === idx && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3,
              ease: 'easeInOut'
            }} data-id="element-70">
                    <div className="px-6 pb-5 text-warm-gray leading-relaxed border-t border-gray-50 pt-4" data-id="element-71">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}